export default function() {}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-contour/src/noop.js
// module id = 323
// module chunks = 0